import FlexContainer from 'components/common/FlexContainer';
import SearchBanner from 'components/search/SearchBanner';
import SearchResults from 'components/search/SearchResults';
import SourceInsitutionNotFound from 'components/search/SourceInstitutionNotFound';
import useSelectedSourceInstitution from 'hooks/use-selected-source-institution';

export default function CreditCalculator(): JSX.Element {
  const { selectedSourceInstitution } = useSelectedSourceInstitution();
  return (
    <FlexContainer className='home'>
      <SearchBanner />
      {selectedSourceInstitution ? (
        <SearchResults sourceInstitution={selectedSourceInstitution} />
      ) : (
        <SourceInsitutionNotFound />
      )}
    </FlexContainer>
  );
}
